import { Component, OnInit } from '@angular/core';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';

@Component({
  selector: 'app-header-admin',
  templateUrl: './header-admin.component.html',
  styleUrls: ['./header-admin.component.scss']
})
export class HeaderAdminComponent implements OnInit {

  adminData:any;
  tcktCount:number=0;
  resetRqstCount:number=0;
  isNavbarCollapsed=true;
  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' }
  constructor(private contentAuthoringApi: ContentAuthoringService,) { }

  ngOnInit(): void {
    this.adminData=JSON.parse(localStorage.getItem('adminData') || '[]');
    this.getTicketCount()
  }

  getTicketCount() {
    const jsonPost={
      email: this.adminData.email
    }
    this.contentAuthoringApi.ticketCountDetail(jsonPost).subscribe(
      (data) => {
        if (data.success) {
          this.tcktCount= data.ticket_count;
          this.resetRqstCount= data.reset_req_count
        } else {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist';
        }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
      },
    );
  }
}
